import { Grid, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";

const LoanGuarantorInlineFields = ({
  values = {},
  errors = {},
  touched = {},
  setFieldValue,
  setFieldTouched,
  disabled = false,
  fieldPrefix = "guarantor",
}) => {
  const field = (name) => `${fieldPrefix}${name}`;
  const get = (name) => values[field(name)] ?? "";
  const err = (name) => errors[field(name)];
  const isTouched = (name) => Boolean(touched[field(name)]);

  const onChange = (name) => (e) => {
    setFieldValue?.(field(name), e.target.value);
  };

  const onBlur = (name) => () => {
    setFieldTouched?.(field(name), true, false);
  };

  return (
    <Grid container spacing={2} sx={{ mt: 0.5 }}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" fontWeight={700}>
          اطلاعات ضامن
        </Typography>
        <Typography variant="body2" color="text.secondary">
          این اطلاعات همین الان ثبت می‌شود تا استعلام ضامن بدون رفت‌وبرگشت بعدی انجام شود.
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          size="small"
          label="نام ضامن"
          value={get("FirstName")}
          onChange={onChange("FirstName")}
          onBlur={onBlur("FirstName")}
          error={isTouched("FirstName") && Boolean(err("FirstName"))}
          helperText={isTouched("FirstName") ? err("FirstName") : ""}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          size="small"
          label="نام خانوادگی ضامن"
          value={get("LastName")}
          onChange={onChange("LastName")}
          onBlur={onBlur("LastName")}
          error={isTouched("LastName") && Boolean(err("LastName"))}
          helperText={isTouched("LastName") ? err("LastName") : ""}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          size="small"
          label="کد ملی ضامن"
          value={get("NationalCode")}
          onChange={onChange("NationalCode")}
          onBlur={onBlur("NationalCode")}
          error={isTouched("NationalCode") && Boolean(err("NationalCode"))}
          helperText={isTouched("NationalCode") ? err("NationalCode") : ""}
          inputProps={{ inputMode: "numeric", maxLength: 10 }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          size="small"
          label="موبایل ضامن"
          value={get("Mobile")}
          onChange={onChange("Mobile")}
          onBlur={onBlur("Mobile")}
          error={isTouched("Mobile") && Boolean(err("Mobile"))}
          helperText={isTouched("Mobile") ? err("Mobile") : ""}
          inputProps={{ inputMode: "numeric", maxLength: 11 }}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

LoanGuarantorInlineFields.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  disabled: PropTypes.bool,
  fieldPrefix: PropTypes.string,
};

export default LoanGuarantorInlineFields;
